export const xlsxToBlob = (xlsx: any): Blob => {
  const blob = new Blob([new Uint8Array([...xlsx].map(char => char.charCodeAt(0)))], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  return blob;
};
